module.exports = __webpack_public_path__ + "r-v3/img/ico_pin_active.3417a3ac.svg";